/**
 * Lenis Smooth Scroll Utility
 */
export class LenisScroll {
    constructor() {
        this.lenis = null;
    }

    init() {
        this.lenis = new Lenis({
            wheelMultiplier: 1, // 기본값 유지 (Hero.js에서 특정 섹션만 가로채기)
            touchMultiplier: 2,
            smooth: true,
            smoothTouch: false,
            duration: 1.2,
        });

        this.lenis.on("scroll", (e) => {
            ScrollTrigger.update();
        });

        gsap.ticker.add((time) => {
            this.lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);
    }

    getInstance() {
        return this.lenis;
    }
}

